module.exports = __webpack_public_path__ + "static/img/Group 1356.ee75e15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images_member/20240302/Group 1356.png
// module id = Uq6p
// module chunks = 1